import { toast } from '@acast/decibel';
import prependToCollection from 'app/collection/actions/prepend';
import createEntity from 'app/entity/actions/create';
import uuid from 'node-uuid';
import { Episode, ShowDrafts } from 'resources';
import EpisodeSchema from 'resources/episode/schema';

export default async showId => {
  try {
    const schema = new EpisodeSchema({
      id: uuid.v4(),
      channel: showId,
      name: 'Untitled Episode',
    });

    const episode = await createEntity(Episode, schema);

    prependToCollection(ShowDrafts, showId, [new EpisodeSchema(episode)]);

    return episode;
  } catch (error) {
    toast.danger(`Error creating episode: ${error.message}`, { closable: true });
    throw error;
  }
};
